import {Opt} from 'ts-opt';

import {ApcStableDate} from 'api/gen/ApcStableDate';

/**
 * Checks whether the current APC stable/date relation payload represents a protocol-backed response.
 *
 * @param stableDateRelations Optional stable/date relations payload.
 * @returns `true` when the payload contains `ApcDateListWithStables`.
 */
export const protocolExists = (stableDateRelations: Opt<ApcStableDate>): boolean =>
    stableDateRelations.exists(relation => relation.tag === 'ApcDateListWithStables');
